(function($){
  
  $(document).ready(function() {
    if($(window).width() >= 1024) {
  
        jQuery('#shopify-section-1594551218998 .collection-slider').slick({
            dots: false,
            arrows: true,
            infinite: false,
            autoplay: false,
            centerMode: false,
            variableWidth: true,
            slidesToShow: 6,
            slidesToScroll: 1,	
            speed: 500,
            responsive: [
                {
                  breakpoint: 1100,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    variableWidth: false			
                  }
                },
                {
                  breakpoint: 990,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    variableWidth: false			
                  }
                },          
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false				
                  }
                }         
            ]
        });
      
	  }
	});      
  
	// Custom carousel nav
	$('.carousel-prev').click(function(){ 
		$(this).parent().find('.slick-slider').slick('slickPrev');
	} );
	
	$('.carousel-next').click(function(e){
		e.preventDefault(); 
		$(this).parent().find('.slick-slider').slick('slickNext');
	} );  
  
    $(document).ready(function() {
      if($(window).width() >= 1101) {

        jQuery('.collection-list-carousel').slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: false,
            centerMode: true,
            variableWidth: false,
            slidesToShow: 6,
            slidesToScroll: 1,	
            speed: 500,		
            responsive: [
                {
                  breakpoint: 990,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    centerMode: false,
                    variableWidth: false			
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false				
                  }
                }
            ]
        }); 

     }
  	});  
  

    $(document).ready(function() {
        jQuery('.collection-mobile').slick({
            dots: false,
            arrows: true,
            infinite: false,
            autoplay: false,
            centerMode: false,
            variableWidth: false,
            slidesToShow: 6,
            slidesToScroll: 1,	
            speed: 500,		
            responsive: [
                {
                  breakpoint: 980,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                    variableWidth: false			
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    variableWidth: false				
                  }
                }
            ]
        }); 

  	});  
  
  	/*
	$(document).ready(function() {
      if($(window).width() <= 990) {
        jQuery('.product-single .product-single__media-group').slick({
         	dots: false,
            arrows: false,
            infinite: false,
            autoplay: false,
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,	
            speed: 500,	
        });   
     }
  	}); 
    */
	
    jQuery(document).ready(function($) {
  var $thumbSlider = $('.product-single__thumbnails');

  // Only init if the slider exists AND has children (slides)
  if ($thumbSlider.length && $thumbSlider.children().length > 0) {
    $thumbSlider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      centerMode: false,
      variableWidth: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 500,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            variableWidth: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            variableWidth: false,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }
});

    
    
  
	$(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });  
  
    $(document).ready(function() {
        if($(window).width() <= 1100) {  
          $('#shopify-section-category-section.withcollapse').addClass('panel-group');
          $('#shopify-section-category-section.withcollapse').attr('id', 'accordion');
          $('#shopify-section-category-section.withcollapse').attr('role', 'tablist');
          $('#shopify-section-category-section.withcollapse').attr('aria-multiselectable', 'true');
          
          $('.withcollapse .feature-row-item').addClass('panel panel-default');
          $('.withcollapse .feature-row .item_heading').addClass('panel-heading');
          $('.withcollapse .feature-row .item_heading').attr('role', 'tab');
          
          $('.withcollapse .feature-row .item_heading .feature-row__image-wrapper').attr('role', 'button');
          $('.withcollapse .feature-row .item_heading .feature-row__image-wrapper').attr('data-toggle', 'collapse');
          $('.withcollapse .feature-row .item_heading .feature-row__image-wrapper').attr('data-parent', 'accordion');
          $('.withcollapse .feature-row .item_heading .feature-row__image-wrapper').attr('aria-expanded', 'false');
          
          $('.withcollapse .feature-row-subs').addClass('panel-collapse collapse');
          $('.withcollapse .feature-row-subs').attr('rolse', 'tabpanel');

          
    	}
	});  
  
	$(".close-button").click(function(){
		$(".announcement-bar").hide();
	});  
  
})(jQuery);  